import { render, staticRenderFns } from "./external_video_card.vue?vue&type=template&id=15fa365e&scoped=true&lang=pug"
import script from "./external_video_card.vue?vue&type=script&lang=js"
export * from "./external_video_card.vue?vue&type=script&lang=js"
import style0 from "./external_video_card.vue?vue&type=style&index=0&lang=scss"
import style1 from "./external_video_card.vue?vue&type=style&index=1&id=15fa365e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15fa365e",
  null
  
)

export default component.exports